"use client";

import { useTheme } from "next-themes";
import type { ToasterProps } from "sonner";
import { Toaster as Sonner } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "#006BFF",
          "--normal-text": "white",
          "--normal-border": "none",
          "--border-radius": "16px",
          "--box-shadow":
            "0 10px 15px -3px rgb(0 0 0 / 0.12), 0 4px 6px -4px rgb(0 0 0 / 0.12)",
          // No `--height`: it was pinned to 120px, which padded a one-line
          // "Saved" out to the size of a paragraph and clipped anything longer.
          // Sonner measures each toast to stack them, so leaving it unset lets
          // the stack track the real heights.
          "--width": "400px",
          "--success-bg": "#006BFF",
          "--success-text": "white",
          "--error-bg": "#EB001C",
          "--error-text": "white",
          "--info-bg": "#006BFF",
          "--info-text": "white",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
